var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 24,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 22 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F2124",
  fillRule: "evenodd",
  d: "M6.297 11.886C5.437 10.683 5 9.14 5 7.5c0-1.797.525-3.476 1.554-4.72C7.596 1.52 9.121.75 11 .75s3.404.77 4.445 2.03C16.476 4.023 17 5.702 17 7.5c0 1.64-.437 3.183-1.297 4.386 3.495 1.177 5.797 4.598 5.797 8.364v3H20v-3c0-3.432-2.255-6.428-5.481-7.137-.948.72-2.138 1.137-3.519 1.137s-2.571-.416-3.519-1.137C4.255 13.822 2 16.818 2 20.25v3H.5v-3c0-3.766 2.302-7.187 5.797-8.364M6.5 7.5c0-1.517.444-2.838 1.21-3.765C8.465 2.823 9.565 2.25 11 2.25s2.535.573 3.29 1.485c.767.927 1.21 2.248 1.21 3.765s-.444 2.838-1.21 3.765q-.108.13-.224.25c.005 0-.006 0 0 0-.755.772-1.802 1.235-3.066 1.235s-2.311-.463-3.066-1.235c.006 0-.005 0 0 0a4 4 0 0 1-.224-.25C6.944 10.338 6.5 9.017 6.5 7.5",
  clipRule: "evenodd"
})));
export default SvgPerson;